module.exports = __webpack_public_path__ + "static/media/jenga-smort.0b5fd609.jpg";